<entry-operation [entry]="entry" [operation]="operation" [editMode]="editMode" *ngFor="let operation of operations"></entry-operation>
